import React from "react";
import { ExternalLink } from "lucide-react";

const PortfolioCard = ({ p, i, testIdPrefix = "portfolio-card" }) => {
  const isComingSoon = !p.url;
  const CardTag = isComingSoon ? "div" : "a";
  const cardProps = isComingSoon
    ? { "aria-disabled": true }
    : { href: p.url, target: "_blank", rel: "noreferrer" };
  return (
    <CardTag
      key={p.name}
      {...cardProps}
      data-testid={`${testIdPrefix}-${i}`}
      className={`group block overflow-hidden rounded-[14px] bg-white bdk-reveal bdk-reveal--up transition-all ${
        isComingSoon ? "cursor-default" : ""
      }`}
      style={{
        border: "1px solid var(--line)",
        "--reveal-delay": `${i * 90}ms`,
      }}
      onMouseEnter={
        isComingSoon
          ? undefined
          : (e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.borderColor = "rgba(217,0,32,.4)";
              e.currentTarget.style.boxShadow =
                "0 22px 45px rgba(17,18,24,.10)";
            }
      }
      onMouseLeave={
        isComingSoon
          ? undefined
          : (e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.borderColor = "var(--line)";
              e.currentTarget.style.boxShadow = "";
            }
      }
    >
      {/* Browser frame */}
      <div
        className="flex items-center gap-1.5 h-9 px-3"
        style={{ background: "var(--ink)" }}
      >
        <span className="w-[7px] h-[7px] rounded-full bg-[#d90020]" />
        <span className="w-[7px] h-[7px] rounded-full bg-[#d90020]" />
        <span className="w-[7px] h-[7px] rounded-full bg-[#d90020]" />
        <span className="ml-3 text-white/50 text-[10px] truncate">
          {isComingSoon
            ? "demo próximamente"
            : p.url.replace("https://", "").replace(/\/$/, "")}
        </span>
      </div>
      <div className="relative aspect-[16/11] overflow-hidden">
        <img
          src={p.image}
          alt={p.name}
          loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-700 ${
            isComingSoon ? "grayscale opacity-70" : "group-hover:scale-105"
          }`}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(17,18,24,0) 30%, rgba(17,18,24,.85) 100%)",
          }}
        />
        <div className="absolute bottom-4 left-4 right-4">
          <span
            className="inline-block px-3 py-1 rounded-full mb-2 text-[10px] font-black uppercase tracking-wider"
            style={{
              background: isComingSoon ? "#3a3a44" : "var(--red)",
              color: "#fff",
            }}
          >
            {p.tag}
          </span>
          <h3 className="font-display text-[26px] text-white leading-none uppercase">
            {p.name}
          </h3>
        </div>
      </div>
      <div className="flex items-center justify-between px-5 py-4">
        <p className="text-[#666873] text-[12px] line-clamp-2 pr-3">
          {p.description}
        </p>
        {isComingSoon ? (
          <span className="text-[#666873] text-[10px] font-black uppercase tracking-widest flex-shrink-0">
            Pronto
          </span>
        ) : (
          <ExternalLink size={16} className="text-[#d90020] flex-shrink-0" />
        )}
      </div>
    </CardTag>
  );
};

export default PortfolioCard;
